import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { OrganizationService } from '../../../../services/organization/organization.service';
import { BillPayService } from '../../../../services/members/bill-pay.service';
import { LegfiCurrencyPipeModule } from '../../../../pipes/format/legfi-currency.module';
import { MicrodepositVerificationModule } from '../../shared/bank-account-manager/microdeposit-verification/microdeposit-verification.module';
import { ModalModule } from '../../../shared/modal/modal.module';
import { MembersService } from '../../../../services/members/members.service';
import { RecaptchaModule } from 'ng-recaptcha';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { EditBillPayAccountComponent } from './edit-bill-pay-account.component';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
        MicrodepositVerificationModule,
        ModalModule,
        LegfiCurrencyPipeModule,
        RecaptchaModule,
        MatDialogModule,
        MatSelectModule,
        MatCheckboxModule,
    ],
    declarations: [EditBillPayAccountComponent],
    exports: [
        EditBillPayAccountComponent,
    ],
    providers: [
        // Services
        BillPayService,
        MembersService,
        OrganizationService,
    ],
})
export class EditBillPayAccountModule
{
}
